import { useMutation } from 'react-query'

import { APIError } from '../../../../utils'
import { sendAsEInvoice } from '../../query-api'

interface UseSendAsEInvoiceOptions {
  onError?: (error?: APIError) => void
  onSuccess?: () => void
}

export const useSendAsEInvoiceMutation = (props?: UseSendAsEInvoiceOptions) => {
  const { onError, onSuccess } = props || {}
  const { mutate: send, isLoading, ...rest } = useMutation(sendAsEInvoice, { onSuccess, onError })

  return { send, isProcessing: isLoading, ...rest }
}
